<div class="customModal" *ngIf="showModal">
  <div data-aos="zoom-in" class="content ">
      <h4 class="msg">Are you sure you want to delete this?</h4>
      <div class="buttons">
        <button (click)="ifYes()" class="customBtn hoverable yes">Yes</button>
      <button (click)="ifNo()" class="customBtn hoverable no">No</button>
      </div>
  </div>
</div>
<div class="container-fluid text-center my-5" >
  <h2 class="display-4 mb-5">Admin Panel<br>

  </h2>  </div>

<div class="row text-center my-5">
 

    <div *ngIf="isLoggedIn" class="card my-5 p-4">
      <i class="fa profileIcon fa-user-circle-o mb-3 fs-3"
            aria-hidden="true"></i>
      <h1>{{userInfo.name}}</h1>
      <p class="title">Joined: {{userInfo.createdAt.slice(0,10)}}</p>
     <div class="d-flex justify-content-center">
      <p class="me-4"><i class="fa fa-phone-square" aria-hidden="true"></i>
        {{userInfo.phone}}</p>
      <p><i class="fa fa-envelope" aria-hidden="true"></i>
        {{userInfo.email}}</p>
     </div>
    </div>


   <div class="row p-5 d-flex justify-content-center">
    <div class="d-flex justify-content-around my-3">
      <div class="col-4 d-flex justify-content-center me-3 "> <a routerLink="/addDog" class="btnv2 btn-sm animated-button thar-one"><i class="fa fa-paw" aria-hidden="true"></i>Add <br>a Dog</a> </div>
      <div class="col-4 d-flex justify-content-center me-3"> <a routerLink="/dogs" class="btnv2 btn-sm animated-button thar-two"><i class="fa fa-paw" aria-hidden="true"></i>Show all <br>Dogs</a> </div>
      <div class="col-4 d-flex justify-content-center"> <a (click)="showUserDogs()" class="btnv2 btn-sm animated-button thar-one"><i class="fa fa-paw" aria-hidden="true"></i>Dogs I've<br>Added</a> </div>
   </div>
      
      <!-- user dogs -->
      

       <div *ngIf="displayUserDogs && usersDogs.length < 1" class="row my-5 d-flex justify-content-center p-5">
        <h4>You haven't added any dogs yet!</h4>
        </div>

       <div *ngIf="displayUserDogs" class="row my-5 d-flex justify-content-center p-5">
        <div data-aos="zoom-out-up" class="card shadow hoverable m-4 " style="width: 18rem;" *ngFor="let dog of usersDogs">
      
          <figure  class="hover-img">
            <div [ngStyle]="{'background-image': 'url(' + dog.image || '../../images.noImg.jpg' + ')'}" class="card-img-top ngBackground" alt="..."></div>
          </figure>
      
          <div class="card-body">
            <h5 class="card-title text-center">{{dog.name}}</h5>
            <p class="card-text text-center">{{dog.description.substr(0,40)}}...</p>
            <div class="d-flex justify-content-evenly">
              <span class="badge bg-warning text-dark customBadge"><i class="fa fa-birthday-cake" aria-hidden="true"></i>
                {{dog.age}} y.o</span>
              <span class="badge bg-warning text-dark customBadge"><i class="fa fa-expand" aria-hidden="true"></i>
                {{dog.size}}</span>
                <span class="badge bg-warning text-dark customBadge"><i class="fa fa-mars" aria-hidden="true"></i>
                   {{dog.gender}}</span>
            </div>
            <div class="d-flex mt-1 justify-content-evenly">
              <span class="badge bg-warning text-dark customBadge"><i class="fa fa-paw" aria-hidden="true"></i>
                :{{dog.breed}}</span>
            </div>
        
          <div class="d-flex justify-content-center my-3">
            <a routerLink="/editDog/{{dog._id}}" class="btn me-2 btn-dark ">Edit <i class="fs-5 fa fa-pencil-square-o" aria-hidden="true"></i>
            </a>
            <a (click)="userDeleteRequest(dog._id)" class="btn btn-danger ">Delete  <i class="fs-5 fa fa-trash-o" aria-hidden="true"></i>
            </a>
          </div>
          </div>
        </div>
        </div>

       </div>